module.exports = __webpack_public_path__ + "resources/img/img_security_ahnlab_vaips_m.7eaeb794237353023bec6deb212b3448.png";